// extracted by mini-css-extract-plugin
export var cell = "_52-4";
export var headerCell = "_52-2";
export var rowHeader = "_52-3";
export var table = "_52-1";
export var tableContainer = "_52-0";